// 店铺审核
const axios = require('axios')
// const qs = require('qs')
const Header = require('./auth')
const {
    GET_SHOPID_NAME_LIST_URL,
    DELETE_SHOP_URL,
    ADD_SHOP_URL
} = require('./url')

/* 获取店铺 */
function getShopNameList ({ pageNum, pageSize, userName }) {
    Header.axiosStop()
    return new Promise((resolve, reject) => {
    axios.get(`${GET_SHOPID_NAME_LIST_URL}/${userName}/${pageNum}/${pageSize}`)
        .then(res => {
        // console.log(res)
        resolve(res)
        })
        .catch(err => {
        reject(err)
        })
    })
}

/* 新增店铺信息 */
function addShop (sendData) {
    Header.axiosStop()
    return new Promise((resolve, reject) => {
        axios.post(`${ADD_SHOP_URL}/${sendData.id}`,
        {
            shopAddr: sendData.shopAddr,
            shopDesc: sendData.shopDesc,
            shopImg: sendData.shopImg,
            shopLevel: sendData.shopLevel,
            shopName: sendData.shopName,
            shopNumber: sendData.shopNumber,
            updateTime: sendData.updateTime,
            userName: sendData.userName
        }
    )
    .then(res => {
        resolve(res)
    })
    .catch(err => {
        reject(err)
    })
    })
}

/* 删除店铺信息 */
function deleteShopId (id) {
return new Promise((resolve, reject) => {
    axios.delete(`${DELETE_SHOP_URL}/${id}`)
        .then(res => {
            // console.log(res)
        resolve(res)
        })
        .catch(err => {
        reject(err)
        })
    })
}

module.exports = {
    deleteShopId,
    addShop,
    getShopNameList
}
